import classNames from "classnames";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SetClickedBreadCrum } from "../../Actions/commonAction";

const Breadcrumbscomponent = (props) => (
    <div className="margin-top-10">
      <p className="position-rel">
        <span className="position-abs">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z" />
          </svg>
        </span>
        {props.list.map((data, index) => (
            <span key="key">
              <span onClick={() => { props.SetClickedBreadCrum(data); }} className={classNames(index == 0 ? "margin-left-30" : "", "breadcum")}>{data}</span>
              <span className={classNames(index == props.list.length - 1 ? "visibilitynone" : "")}/>
            </span>
          ))}
      </p>
    </div>
  );

const mapStateToProps = (state) => ({
    selectionReducer: state.selectionReducer,
  });

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
      SetClickedBreadCrum,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Breadcrumbscomponent);
